<script>
    import { _ } from 'svelte-i18n';
    import { url } from '../stores/url.js';
    import { user } from '../stores/user.js';   
    import Modal from '../components/Modal.svelte';
    import Spinkit from '../components/Spinkit.svelte';
    import { date, getLocation, hhmm, padNumber, successNotification } from '../functions/html-helpers';
    import { request } from '../functions/http-helpers';
    import { Loader } from '@googlemaps/js-api-loader';
    import { onMount } from 'svelte';
 
    
 

    /* SETUP */
    let day = null;
    let loading_day = true;
    let current_time = '';
    let weekday = '';
    let bv_day_note = '';

    let clocking_in = false;
    let clocking_out = false;

    let d = new Date(); 
    let user_months = [];
    let minutes_since_clocked_in = '';
    let ping_result = '';
    weekday = 'day_' + d.getDay(); 
    current_time = date('H:i:s', new Date()); 
    $: userContract = $user && $user.contracts ? $user.contracts.find(c => c.active == true) : null;
    setInterval(() => {
        const now = new Date();
        current_time = date('H:i:s', now);  

        /*
        if(day) {
            const ms_diff = Math.abs(now.getTime() - new Date(day.start_time).getTime());
            const min_diff = Math.floor(ms_diff / (1000 * 60));
            minutes_since_clocked_in = min_diff;
        }
        */        
    }, 1000);
    getDay();
    getMonths();
    ping();



    /* Watch */




    /* HTML inserts */




    /* GET */
    async function getDay() {
        const [data, error] = await request(`${$url}/day/today`);
        if(!error) {
            loading_day = false;
            day = data;
            if(day) { 
                const now = new Date(); 
                const ms_diff = Math.abs(now.getTime() - new Date(day.start_time).getTime());
                const min_diff = Math.floor(ms_diff / (1000 * 60));
                minutes_since_clocked_in = min_diff;    
                bv_day_note = day.note;
            }            
        }
    } 


    async function getMonths() { // unschön, sollte eigentlich bei login mitgegeben werden aber daten sind im derzeitigen softwarestand nicht im dom
        const [data, error] = await request(`${$url}/user/user_months`);
        if(!error) {
            user_months = data;
        }
    }



    /* POST */
    async function clockIn() {
        // if(!clocking_in) {
            // clocking_in = true;
            const location = await getLocation();
            const [data, error] = await request(`${$url}/day/clock_in`, {
                start_location: `${location[0]}_${location[1]}`, 
            });
            if(!error) { 
                day = data;
            }
            clocking_in = false;
        // }
    }

    async function ping() {
        const start_time = parseInt(new Date().getTime()); 
        const [data, error] = await request(`${$url}/day/ping`);
        const end_time = parseInt(new Date().getTime()); 

        ping_result = parseInt(end_time - start_time);
    }


    async function clockOut() {
        if(!clocking_out) {
            clocking_out = true;
            const location = await getLocation();
            const [data, error] = await request(`${$url}/day/clock_out/${day?.id}`, {
            end_location: `${location[0]}_${location[1]}`,  
            });
            if(!error) {  
                day = data; 
            }
            clocking_out = false;
        }
        
    }


    async function updateDayNote() {
        const [data, error] = await request(`${$url}/day/update_note/${day?.id}`, {
            note: bv_day_note
        });
        if(!error) { 
            successNotification('Bemerkung gespeichert');
            day = data;
        }
    }

</script>




<div class="uk-container"> 
    <div class="card uk-margin-top uk-margin-medium-bottom">
		<h3 style="color: white">
            {$_('hello')}
            {$user.firstname} {$user.lastname}
        </h3>

        <!-- 
        <div id="map" style="width: 100%; height: 300px; "></div>
        -->

        <p>
            {$_('it-is')}
            {$_(`${weekday}`)} 
            {current_time}
            {$_('o-clock')}
        </p>

        <div class="uk-margin-top uk-margin-bottom">
            <div class="uk-alert uk-alert-info uk-background-secondary" uk-alert>
                <p>ping: {ping_result} ms</p>
            </div>
        </div>


        <!--
        <p>
            Gesamt Übestunden: 
            {#if user_months.length}
                {hhmm(user_months.find(um => date('Y-m', new Date(um.month_date)) == date('Y-m', new Date()))?.total_overtime_minutes)}
            {/if}
        </p>
        -->
 
        <!--
        <p> 
            {$_('user-hours-total')}: 
            in user profile und dann onMount nachladen aus dem backends  
            {$user.contracts.find(c => c.active)?.current_overtime_minutes}
            <br>
            13 {$_('of')} {$user.contracts.find(c => c.active)?.monthly_hours}
        </p>
        --> 

        <div uk-grid>
            <div class="uk-width-1-1">
                {#if loading_day}
                    <Spinkit />
                {:else if userContract}
                    {#if !day}
                        <button class="btn btn-primary uk-align-center" on:click={() => clockIn()}>
                            <!--
                            {#if clocking_in}
                                <span uk-spinner></span>
                            {:else}
                                {$_('clock-in')}    
                            {/if}
                            -->
                            {$_('clock-in')}   
                        </button> 
                    {:else}
                        {#if day && !day.vacation_day && !day.faz_day && !day.public_holiday}
                            <p>
                                {$_('clocked-in')}: 
                                {date('H:i', new Date(day.start_time))}
                                {$_('o-clock')}
                            </p>
                            {#if !day.end_time}
                                {#if minutes_since_clocked_in && (minutes_since_clocked_in > userContract.default_break)}
                                    <button class="btn btn-primary uk-align-center" on:click={() => clockOut()}>
                                        {#if clocking_out}
                                            <span uk-spinner></span>
                                        {:else} 
                                            {$_('clock-out')}
                                        {/if}
                                    </button> 
                                {:else}
                                    <div class="uk-alert-warning" uk-alert>
                                        {$_('work-one-hour-before-clock-out')}
                                    </div> 
                                {/if}
                            {:else}
                                <p>  
                                    {$_('clocked-out')}:
                                    {date('H:i', new Date(day.end_time))}
                                    {$_('o-clock')} 
                                </p> 

                                <!-- zweites einstemepln -->
                                {#if day.start_time2}
                                    <p>
                                        {$_('clocked-in-again')}:
                                        {date('H:i', new Date(day.start_time2))}
                                        {$_('o-clock')}
                                    </p>
                                    {#if day.end_time2}
                                        <p>  
                                            {$_('clocked-out-again')}:
                                            {date('H:i', new Date(day.end_time2))}
                                            {$_('o-clock')}
                                        </p> 
                                    {:else}
                                        <button class="btn btn-primary uk-align-center" on:click={() => clockOut()}>
                                            {$_('clock-out')}
                                        </button> 
                                    {/if} 
                                {:else}
                                    <button class="btn btn-primary uk-align-center" on:click={() => clockIn()}>
                                        {$_('clock-in-again')}
                                    </button>
                                {/if}

                                <p>
                                    {$_('hours-worked')}:
                                    {padNumber(parseInt(day.minutes_worked / 60))}:{padNumber(parseInt(day.minutes_worked % 60))} 
                                </p>
                            {/if}
                        {:else if day.vacation_day}
                            <p>Du hast heute Urlaub</p>
                        {:else if day.faz_day} 
                            <p>Du hast heute Überstunden</p>
                        {:else if day.public_holiday}
                            <p>Heute ist Feiertag</p>
                        {/if}

                        <label>Bemerkung: </label>
                        <textarea class="uk-textarea" rows="5" bind:value={bv_day_note} on:blur={() => updateDayNote()}></textarea>
                    {/if}
                {/if}
            </div>
        </div>
        
	</div>
</div>